<ng-template #copyPaymentLinkButton let-url="url">
    <span class="link" (click)="copyPaymentLink(url)">
        Copiar link
    </span>
</ng-template>
<app-nav titulo="Detalle de la garantía" descripcion="Aquí podrá ver todos los datos que tenemos hasta ahora de la garantía seleccionada.">
    <div class="warranty-details" *ngIf="warranty">
        <div class="status-box" [ngClass]="{ pending: ['DOCUMENTACION', 'PAGO_PENDIENTE', 'GENERAR_CONTRATO', 'AUTORIZACION_PENDIENTE', 'FIRMA_DIGITAL', 'FIRMA_PENDIENTE'].includes(warranty.estado), active: ['ACTIVA', 'FINALIZADA'].includes(warranty.estado), down: ['BAJA_ANTICIPADA', 'BAJA_POR_ADMIN', 'BAJA_POR_AGENTE'].includes(warranty.estado) }">
            <span class="status-box-title">Estado</span>
            <span class="status-box-description">{{ warranty.estado.replace('_', ' ') }}</span>
        </div>
        <div class="section general-section">
            <span class="section-title">
                Información general
            </span>
            <div class="section-box general-details">
                <app-data-printer-v2 [categories]="generateGeneralInformationCategories(warranty)"></app-data-printer-v2>
            </div>
        </div>
        <div class="section office-section" *ngIf="warranty.agente?.oficina">
            <span class="section-title">
                Oficina
            </span>
            <div class="section-box office-details">
                <app-data-printer-v2 [categories]="generateOfficeCategories(warranty.agente.oficina)"></app-data-printer-v2>
            </div>
        </div>
        <div class="section broker-section" *ngIf="warranty.agente">
            <span class="section-title">
                Agente
            </span>
            <div class="section-box broker-details">
                <app-data-printer-v2 [categories]="generateBrokerCategories(warranty.agente)"></app-data-printer-v2>
            </div>
        </div>
        <div class="section broker-section" *ngIf="!warranty.agente">
            <span class="section-title">
                Agente
            </span>
            <div class="section-box no-broker">
                <ng-container *ngIf="warranty.pagos?.verificado; else brokerPagoPendiente">
                    No se ha asignado un agente a esta garantía
                    <button mat-raised-button color="primary" type="button" class="garantor-button mini select-broker-button" (click)="openAssignBrokerModal()" *ngIf="canEdit">
                        Asignar agente
                    </button>
                </ng-container>
                <ng-template #brokerPagoPendiente>
                    El agente se podrá asignar una vez verificado el pago.
                </ng-template>
            </div>
        </div>
        <div class="section quotation-section">
            <span class="section-title">
                Cotización
            </span>
            <div class="section-box quote-details">
                <app-data-printer-v2 [categories]="generateQuotationCategories(warranty.cotizacion, utilsService)"></app-data-printer-v2>
                <button mat-raised-button color="accent" type="button" class="garantor-button mini requotation-button" (click)="openRequotationDialog()" *ngIf="canEdit && warranty.estado === 'DOCUMENTACION'">
                    Volver a cotizar
                </button>
            </div>
        </div>
        <div class="section scoring-section" *ngIf="warranty.informe">
            <span class="section-title">
                Informe
            </span>
            <div class="section-box scoring-details">
                <app-data-printer-v2 [categories]="generateScoringCategories(warranty.informe)"></app-data-printer-v2>
                <a [routerLink]="'/informes/' + warranty.informe.id" target="_blank">
                    <button mat-raised-button color="primary" type="button" class="garantor-button mini">
                        Ver detalles
                    </button>
                </a>
                <button mat-raised-button color="accent" type="button" class="garantor-button mini" (click)="approveScoring()" *ngIf="canEdit && warranty.informe.dictamen !== 'APROBADO' && !warranty.informe.aprobacionManual">
                    Aprobar
                </button>
                <button mat-raised-button color="accent" type="button" class="garantor-button mini rescoring-button" (click)="openRescoringDialog()" *ngIf="canEdit && ['DOCUMENTACION', 'PAGO_PENDIENTE', 'GENERAR_CONTRATO'].includes(warranty.estado)">
                    Volver a generar informe
                </button>
            </div>
        </div>
        <div class="section tenants-section">
            <span class="section-title">
                Inquilinos
            </span>
            <div class="section-box tenant-details" *ngIf="warranty.inquilinos?.length">
                <div class="tenant" *ngFor="let tenant of warranty.inquilinos; let i = index">
                    <span class="subsection-title"> Inquilino número {{ i + 1 }} </span>
                    <app-data-printer-v2 [categories]="generateTenantCategories(tenant)"></app-data-printer-v2>
                    <div class="edit-tenant-row" *ngIf="canEdit">
                        <a [routerLink]="'/inquilinos/' + tenant.id + '/editar'" target="_blank">
                            <button mat-raised-button color="primary" type="button" class="garantor-button mini edit-tenant-button">
                                Modificar inquilino
                            </button>
                        </a>
                        <button mat-icon-button type="button" class="refresh-button" color="primary" (click)="getWarranty(warranty.id)">
                            <mat-icon>refresh</mat-icon>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="section owners-section">
            <span class="section-title">
                Propietarios
            </span>
            <div class="section-box no-property" *ngIf="!warranty.propiedad">
                No se ha seleccionado una propiedad
            </div>
            <div class="section-box no-owner" *ngIf="warranty.propiedad && !warranty.propiedad?.propietarios?.length">
                No hay propietarios asociados a la propiedad
            </div>
            <div class="section-box owner-details" *ngIf="warranty.propiedad?.propietarios?.length">
                <div class="owner" *ngFor="let owner of warranty.propiedad.propietarios; let i = index">
                    <span class="subsection-title"> Propietario número {{ i + 1 }} </span>
                    <app-data-printer-v2 [categories]="generateOwnerCategories(owner)"></app-data-printer-v2>
                    <div class="edit-owner-row" *ngIf="canEdit">
                        <a [routerLink]="'/propietarios/' + owner.id + '/editar'" target="_blank">
                            <button mat-raised-button color="primary" type="button" class="garantor-button mini edit-owner-button">
                                Modificar propietario
                            </button>
                        </a>
                        <button mat-icon-button type="button" class="refresh-button" color="primary" (click)="getWarranty(warranty.id)">
                            <mat-icon>refresh</mat-icon>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="section property-section">
            <span class="section-title">
                Propiedad
            </span>
            <div class="section-box no-property" *ngIf="!warranty.propiedad">
                No se ha seleccionado una propiedad
                <button mat-raised-button color="primary" type="button" class="garantor-button mini select-property-button" (click)="openSelectPropertyModal()" *ngIf="canEdit">
                    Seleccionar propiedad
                </button>
            </div>
            <div class="section-box property-details" *ngIf="warranty.propiedad">
                <app-data-printer-v2 [categories]="generatePropertyCategories(warranty.propiedad)"></app-data-printer-v2>
                <div class="edit-property-row" *ngIf="canEdit">
                    <a [routerLink]="'/propiedades/' + warranty.propiedad.id + '/editar'" target="_blank">
                        <button mat-raised-button color="primary" type="button" class="garantor-button mini edit-property-button">
                            Modificar propiedad
                        </button>
                    </a>
                    <button mat-icon-button type="button" class="refresh-button" color="primary" (click)="getWarranty(warranty.id)">
                        <mat-icon>refresh</mat-icon>
                    </button>
                </div>
            </div>
        </div>
        <div class="section documentation-section">
            <span class="section-title">
                Documentación
            </span>
            <div class="section-box documentation-initialization" *ngIf="!warranty.formularios?.length">
                No se ha solicitado documentación
                <div class="documentation-initialization-buttons" *ngIf="canEdit">
                    <button mat-raised-button color="primary" type="button" class="garantor-button mini" (click)="requestInitialDocumentation()" [disabled]="!getWarrantyEmail(warranty)">
                        Solicitar documentación inicial
                    </button>
                    <button mat-raised-button color="primary" type="button" class="garantor-button mini" (click)="openRequestDocumentationModal()" [disabled]="!getWarrantyEmail(warranty)">
                        Nuevo formulario
                    </button>
                </div>
                <span class="no-warranty-email-message" *ngIf="!getWarrantyEmail(warranty)">
                    Debe configurar el email del inquilino para poder solicitar documentación.
                </span>
            </div>
            <div class="section-box documentation-results" *ngIf="warranty.formularios?.length">
                <div class="form-preview" *ngFor="let form of warranty.formularios.slice().reverse(); let i = index">
                    <span class="form-preview-title">Formulario número {{warranty.formularios.length - i}}</span>
                    <span class="form-preview-description" *ngIf="form.estado === 'CERRADO'">
                        Formulario enviado el {{ utilsService.beautifyDate(form.fechaCreacion, 'L') }} a las {{ utilsService.beautifyDate(form.fechaCreacion, 'HH:mm') }}
                    </span>
                    <span class="form-preview-description" *ngIf="form.estado === 'CANCELADO'">
                        El cliente informó que no tiene los datos para completar el formulario.
                    </span>
                    <div class="waiting-for-answer" *ngIf="form.estado === 'PENDIENTE' && !isFormExpired(form)">
                        <span class="form-preview-description">
                            Ya fueron solicitados los datos al cliente, una vez completado los podrá ver en esta misma sección.
                        </span>
                        <div class="field-preview" *ngFor="let field of form.campos">
                            <span class="field-name">{{ field.nombre }}</span>
                            <span class="field-value">PENDIENTE</span>
                        </div>
                        <span class="link update-data" (click)="getWarranty(warranty.id)">
                            Actualizar
                        </span>
                        <a class="link manually-fill complete" [href]="form.url" target="_blank" *ngIf="canEdit">
                            Completar formulario manualmente
                        </a>
                        <a class="link resend-form" (click)="resendForm(form)" *ngIf="canEdit">
                            Volver a enviar email al inquilino
                        </a>
                    </div>
                    <span class="form-preview-description" *ngIf="form.estado === 'PENDIENTE' && isFormExpired(form)">
                        El tiempo de entrega del formulario ha vencido.
                    </span>
                    <ng-container *ngIf="form.estado === 'CERRADO'">
                        <div class="field-preview" *ngFor="let field of form.campos">
                            <span class="field-name">{{ field.nombre }}</span>
                            <span class="field-value" *ngIf="field.tipo === 'INPUT'">{{ field.respuesta }}</span>
                            <span class="field-value link" (click)="downloadDocument(field.respuesta)" *ngIf="field.tipo === 'UPLOAD'">
                                Descargar archivo
                            </span>
                        </div>
                    </ng-container>
                </div>
                <button mat-raised-button color="accent" type="button" class="garantor-button mini new-form-button" (click)="openRequestDocumentationModal()" *ngIf="canEdit">
                    Solicitar más documentación
                </button>
            </div>
        </div>
        <div class="section payment-section" *ngIf="warranty.pagos">
            <span class="section-title">
                Pago
            </span>
            <div class="section-box pending-payment-details" *ngIf="!warranty.pagos.principal">
                <app-data-printer-v2 [categories]="generatePendingPaymentCategories(warranty.pagos)"></app-data-printer-v2>
                <span class="link update-data" (click)="getWarranty(warranty.id)">
                    Actualizar
                </span>
                <div class="payment-buttons" *ngIf="canEdit">
                    <button mat-raised-button color="primary" type="button" class="garantor-button mini" (click)="resendPaymentEmail()">
                        Volver a enviar email
                    </button>
                    <a [href]="warranty.pagos.url" target="_blank" rel="noopener noreferrer">
                        <button mat-raised-button color="primary" type="button" class="garantor-button mini">
                            Completar manualmente
                        </button>
                    </a>
                </div>
            </div>
            <div class="section-box payment-details" *ngIf="warranty.pagos.principal">
                <app-data-printer-v2 [categories]="paymentCategories"></app-data-printer-v2>
                <span class="link update-data" (click)="getWarranty(warranty.id)">
                    Actualizar
                </span>
                <div class="payment-buttons">
                    <button mat-raised-button color="primary" type="button" class="garantor-button mini" (click)="verifyPayment()" *ngIf="canEdit && !warranty.pagos.verificado">
                        Confirmar pago
                    </button>
                    <a [href]="warranty.pagos.url" target="_blank" rel="noopener noreferrer" *ngIf="canEdit && !warranty.pagos.verificado">
                        <button mat-raised-button color="primary" type="button" class="garantor-button mini">
                            Completar manualmente
                        </button>
                    </a>
                    <button mat-raised-button color="primary" type="button" class="garantor-button mini" (click)="downloadDocument(comprobante)" *ngFor="let comprobante of warranty.pagos.principal.comprobantes; let i = index">
                        Descargar comprobante {{ warranty.pagos.principal.comprobantes.length > 1 ? (i + 1) : '' }}
                    </button>
                </div>
            </div>
        </div>
        <div class="section contract-section" *ngIf="warranty.contratos">
            <span class="section-title">
                Contrato
            </span>
            <div class="section-box contract-details">
                <app-data-printer-v2 [categories]="generateContractCategories(warranty.contratos)"></app-data-printer-v2>
                <span class="download-signed-contract link" *ngFor="let signedContract of warranty.capturasFirmaContrato" (click)="downloadDocument(signedContract.id)">
                    Descargar contrato firmado el {{ utilsService.parseByType(signedContract.fechaCreacion, 'date') }}
                </span>
                <div class="contract-buttons">
                    <button mat-raised-button color="primary" type="button" class="garantor-button mini" (click)="downloadDocument(warranty.contratos.contratoGarantia.id)" *ngIf="warranty.contratos.contratoGarantia">
                        Descargar contrato (.pdf)
                    </button>
                    <button mat-raised-button color="primary" type="button" class="garantor-button mini" (click)="downloadDocument(warranty.contratos.contratoGarantiaDoc.id)" *ngIf="warranty.contratos.contratoGarantiaDoc">
                        Descargar contrato (.docx)
                    </button>
                    <button mat-raised-button color="accent" type="button" class="garantor-button mini" (click)="openGenerateContractDialog()" *ngIf="canEdit && ['AUTORIZACION_PENDIENTE', 'FIRMA_DIGITAL', 'FIRMA_PENDIENTE'].includes(warranty.estado)">
                        Regenerar contrato
                    </button>
                    <button mat-raised-button color="accent" type="button" class="garantor-button mini" (click)="signedContractUploader.click()" *ngIf="canEdit && warranty.estado === 'ACTIVA'">
                        Subir contrato firmado
                    </button>
                    <input #signedContractUploader class="signed-contract-uploader" type="file" (change)="uploadSignedContract($event)">
                </div>
            </div>
        </div>
        <div class="section authorizations-section" *ngIf="warranty.autorizaciones">
            <span class="section-title">
                Autorizaciones
            </span>
            <div class="section-box authorization-details" *ngFor="let authorization of warranty.autorizaciones" [ngClass]="{ pending: !authorization.fechaConfirmacion, approved: authorization.fechaConfirmacion && authorization.aprobada }">
                <span class="subsection-title" *ngIf="!authorization.fechaConfirmacion"> Autorización pendiente </span>
                <span class="subsection-title" *ngIf="authorization.fechaConfirmacion && authorization.aprobada"> Autorización aprobada </span>
                <span class="subsection-title" *ngIf="authorization.fechaConfirmacion && !authorization.aprobada"> Autorización rechazada </span>
                <app-data-printer-v2 [categories]="generateAuthorizationCategories(authorization)"></app-data-printer-v2>
                <span class="link update-data" (click)="getWarranty(warranty.id)" *ngIf="!authorization.aprobada">
                    Actualizar
                </span>
                <div class="authorization-buttons" *ngIf="canEdit && !authorization.fechaConfirmacion">
                    <button mat-raised-button color="primary" type="button" class="garantor-button mini approve-authorization-button" (click)="reportAuthorization(authorization, 'aprobacion')">
                        Aprobar
                    </button>
                    <button mat-raised-button color="primary" type="button" class="garantor-button mini reject-authorization-button" (click)="reportAuthorization(authorization, 'rechazo')">
                        Rechazar
                    </button>
                    <button mat-raised-button color="primary" type="button" class="garantor-button mini resend-authorization-email" (click)="resendAuthorizationEmail(authorization)">
                        Reenviar email
                    </button>
                </div>
            </div>
        </div>
        <div class="section active-section" *ngIf="warranty.estado === 'ACTIVA'">
            <div class="active-details">
                ¡La garantía ya está activa!
            </div>
        </div>
        <div class="section done-section" *ngIf="warranty.estado === 'FINALIZADA'">
            <div class="done-details">
                ¡La garantía ya fue finalizada!
            </div>
        </div>
        <div class="section down-section" *ngIf="warranty.estado === 'BAJA_ANTICIPADA' || warranty.estado === 'BAJA_POR_ADMIN' || warranty.estado === 'BAJA_POR_AGENTE'">
            <div class="down-details">
                La garantía fue dada de baja
            </div>
        </div>
        <div class="buttons">
            <button mat-raised-button color="accent" type="button" class="garantor-button down-button" (click)="deleteWarranty()" *ngIf="canEdit">
                Dar de baja
            </button>
            <div class="button-with-tooltip" *ngIf="canEdit && warranty.estado === 'DOCUMENTACION'">
                <button mat-raised-button color="primary" type="button" class="garantor-button" (click)="requestPayment()" [disabled]="!scoringHabilitaPago()">
                    Solicitar pago
                </button>
                <span class="button-tooltip" *ngIf="!scoringHabilitaPago() && warranty.informe?.dictamen === 'RECHAZADO' && !warranty.informe?.aprobacionManual">
                    El informe de riesgo fue rechazado. Requiere aprobación por excepción para solicitar el pago.
                </span>
                <span class="button-tooltip" *ngIf="!scoringHabilitaPago() && warranty.informe?.dictamen === 'REVISION' && !warranty.informe?.aprobacionManual">
                    El informe requiere aprobación manual antes de solicitar el pago.
                </span>
                <span class="button-tooltip" *ngIf="!scoringHabilitaPago() && warranty.informe?.aprobacionManual && !allRequiredFormsCompleted()">
                    Debe tener al menos un formulario cargado y los obligatorios completos antes de solicitar el pago.
                </span>
            </div>
            <div class="button-with-tooltip" *ngIf="canEdit && warranty.estado === 'GENERAR_CONTRATO'">
                <button mat-raised-button color="primary" type="button" class="garantor-button" (click)="openGenerateContractDialog()" [disabled]="!!contractPendingRequirement()">
                    Generar contrato
                </button>
                <span class="button-tooltip" *ngIf="contractPendingRequirement() as pendingRequirement">
                    {{ pendingRequirement }}
                </span>
            </div>
            <button mat-raised-button color="primary" type="button" class="garantor-button" (click)="digitalSignedContractUploader.click()" *ngIf="canEdit && warranty.estado === 'FIRMA_DIGITAL'">
                Subir contratos firmados
            </button>
            <input #digitalSignedContractUploader class="digital-signed-contract-uploader" type="file" (change)="uploadDigitalSignedContract($event)">
            <div class="button-with-tooltip" *ngIf="canEdit && warranty.estado === 'FIRMA_PENDIENTE'">
                <button mat-raised-button color="primary" type="button" class="garantor-button" (click)="reportSignature()" [disabled]="!readyToSign()">
                    Confirmar firma
                </button>
                <span class="button-tooltip" *ngIf="!readyToSign()">
                    No se puede registrar la firma hasta llegada la fecha de firma configurada en el contrato.
                </span>
            </div>
            <button mat-raised-button color="primary" type="button" class="garantor-button" routerLink="./administracion" *ngIf="showAdministrationButton()">
                Administrar pagos
            </button>
        </div>
    </div>
</app-nav>
